import { Controller } from "remult";

@Controller("position-methods")
export class PositionMethods {}
